import { Key, Car, AlertCircle, Tag } from "lucide-react";
import { Badge } from "@/components/ui/badge";
import { LicensePlate } from "@/components/my-auctions/LicensePlate";
import { getLanguage } from "@/utils/languageUtils";
import { vehicleCardUILabels } from "@/i18n";

interface CarCardHeaderProps {
  regNumber: string;
  id: string;
  make: string;
  model: string;
  status: string;
}

export const CarCardHeader = ({
  regNumber,
  id,
  make,
  model,
  status,
}: CarCardHeaderProps) => {
  const uiLabels = vehicleCardUILabels(getLanguage());
  
  return (
    <div className="space-y-3">
      <div className="grid grid-cols-2 sm:grid-cols-4 gap-2 sm:gap-4">
        <div className="flex items-center gap-1 sm:gap-2">
          <Tag className="h-4 w-4 text-muted-foreground" />
          <div>
            <div className="text-xs text-muted-foreground">{uiLabels.registrationNumber}</div>
            <LicensePlate lpn={regNumber} />
          </div>
        </div>

        <div className="flex items-center gap-1 sm:gap-2">
          <Key className="h-4 w-4 text-muted-foreground" />
          <div>
            <div className="text-xs text-muted-foreground">{uiLabels.id}</div>
            <div className="font-semibold text-xs sm:text-base">{id}</div>
          </div>
        </div>

        <div className="flex items-center gap-1 sm:gap-2">
          <Car className="h-4 w-4 text-muted-foreground" />
          <div className="min-w-0 flex-1">
            <div className="text-xs text-muted-foreground">{uiLabels.vehicle}</div>
            <div className="font-semibold text-xs sm:text-base break-words">
              {make} {model}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
